export default "__VITE_ASSET__BdiQXT$E__"